import * as React from 'react';
import { useBOMStore } from 'src/hooks/bom';
import useReduxState from 'src/hooks/useReduxState';
import { isObject } from "underscore";
import store from 'src/storeWire';
import { remove_selected_field } from "src/store/slice/model/BOM/BOMExactMatch";
import Constants from 'src/helper/Constants';
import System from 'src/helper/system';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';

const BomRemovePart = (props) => {
    const { bomId, bomDetailId, singleBomDetail,removeType,removePartNumber } = props

    const [{ bom_detail_by_bom_id, bom_detail_by_bom_id_type,bom_health_by_bom_id, bomSortByUpdatedDate ,bom_project_list}, { get_bom_detail_by_bom_id_with_type, get_bom_health_by_bom_id  }, { remove_part_number,set_bom_multi_match_trigger }] = useBOMStore();
    const [top] = useReduxState({}, 'BOM_DETAIL_TOP_PARAM_FOP_LIMIT', true);
    const { bomDetailPageTabs } = Constants
    const bomTabType = System.getParams().__c_BomTabList || bomDetailPageTabs.BomExactMatchTable.content;
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const onRemovePart = async (bomDetailId, bomId) => {
        let params = {
            bomDetailId: bomDetailId,
            bomId: bomId
        }

        let removePartRes = await remove_part_number(params)

        if (removePartRes?.data) {
            let top_here = 10;
            if (top[bomDetailPageTabs[bomTabType].api_fetch_type] && top[bomDetailPageTabs[bomTabType].api_fetch_type].top) {
                top_here = top[bomDetailPageTabs[bomTabType].api_fetch_type].top;
            }

            top_here = top_here === 10 ? 20 : (top_here - 1);

            let param = {
                bomId: bomId,
                matchType: bomDetailPageTabs[bomTabType].api_fetch_type,
                top: top_here,
                skip: 0
            }

            if (bomSortByUpdatedDate) {
                param.sortColumn = "updated_date"
                param.sortOrder = "desc"
            }

            if(removeType){
                removeMatchesEvent(removeType);
            }


           const res= await get_bom_detail_by_bom_id_with_type(param);

            store.dispatch(remove_selected_field({
                bomDetailId: bomDetailId
            }));

            if (bom_health_by_bom_id && isObject(bom_health_by_bom_id) && Object.entries(bom_health_by_bom_id).length > 0 && singleBomDetail?.product && singleBomDetail.product.LifeCycleRisk.trim()) {
                await get_bom_health_by_bom_id({ bomId: bomId })
            }
            if(res?.payload?.data?.[bomDetailPageTabs[bomTabType]?.api_fetch_type]?.count==0){
                set_bom_multi_match_trigger({
                    BOMTriggerVal: 'BOM_EXACT_TRIGGER'
                })
            }
        }
    }
    function removeMatchesEvent(removeType){
        let eventType ;
        if(removeType ===  "exactMatches") {
            eventType = "bomProductRemoval";
        }
        else if(removeType ===  "multipleMatches") {
            eventType = "bomProdRemoveMultipleResolved";
        }
        else if(removeType ===  "noMatches") {
            eventType = "bomProdRemoveNoMatchesResolved";
        }
        localStorage.setItem("adobeEventType",eventType);
        let bomDetails = {
            bomId:bom_detail_by_bom_id.bomId,
            bomName :bom_detail_by_bom_id.bomName,
            exactMatchCount: bom_detail_by_bom_id_type?.Exact?.count,
            nomatchCount: bom_detail_by_bom_id_type?.NoMatch?.count,
            multipleMatchCount: bom_detail_by_bom_id_type?.Multiple?.count,
            newBOM : bom_detail_by_bom_id?.newBOM,
            source: bom_detail_by_bom_id?.source
          };
          if(bom_project_list){
            bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
          }
        let partNumber = removePartNumber;
        if(removeType === "exactMatches"){
            let prodDetails = (singleBomDetail?.product) ? {...singleBomDetail?.product} : {...singleBomDetail};
            prodDetails.qas = get_inventory_by_id(prodDetails.ItemNumber)?.inventoryQty || 0;
            let pricingDetails = getPricing(prodDetails);
            prodDetails.priceSource = pricingDetails?.priceSource;
            prodDetails.unitPrice = prodDetails.unitPrice || pricingDetails?.marketPrice;
            prodDetails.subtotal = prodDetails.subtotal || (pricingDetails?.marketPrice * pricingDetails?.quantity);
              
            if(Object.keys(bomDetails).length) {
                HelperAdobeEvent.trackingAdobeEvent({bomDetails,prodDetails});
            }
        }
        else {
            if(Object.keys(bomDetails).length) {
                HelperAdobeEvent.trackingAdobeEvent({bomDetails,partNumber});
            }
        }
        


    }

    const getPricing = (ele) => {
        let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
        return priceValues && priceValues[0];
    }
      

    return (
        <>
            <i className="fa fa-trash font-16 ms-2 cursor-pointer text-black-stone"
                onClick={() => onRemovePart(bomDetailId, bomId)}></i>
        </>
    );
}

export default BomRemovePart;